import LinkingTemplate from "../../../components/Forms/linkingTemplate";
import ProjectSources from "./components/projectSources";

export function Template({
  template,
  namespace,
  conf,
  user,
}) {
  switch (namespace) {
    case 'document':
      switch (template) {
        case 'linkingSubjects':
          return (
            <LinkingTemplate conf={conf} namespace={namespace} />
          );
        default:
          return null;
      }

    case 'project':
      switch (template) {
        case 'projectClients':
        case 'projectSources':
          return <ProjectSources user={user} conf={conf} />;
        default:
          return null;
      }

    default:
      return null;
  }
}
